import {Component, Input, OnInit} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon'
import {DomSanitizer} from '@angular/platform-browser'

@Component({
  selector: 'shared-error-ui',
  templateUrl: './error-ui.component.html',
  styleUrls: ['./error-ui.component.scss']
})
export class ErrorUiComponent {

  @Input()
  numerSzkody = ''

  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    this.skonfigurujIkoneError()
  }

  private skonfigurujIkoneError(): void {
    this.initIcon('error', './assets/images/error_icon.svg');
  }

  private initIcon(name: string, url: string): void {
    this.matIconRegistry.addSvgIcon(
      name, this.domSanitizer.bypassSecurityTrustResourceUrl(url)
    );
  }

}
